import { BuildConfig } from '@common/util-models';
import { NavigationLink } from '@domgen/dgx-fe-business-models';

const headerLinks: BuildConfig['header'] = {
  home: {
    href: 'https://www.domesticandgeneral.com',
    label: 'home',
  },
  products: {
    label: 'Get protected',
    routerPath: '/products',
  },
  repair: {
    label: 'Book a repair',
    href: 'https://www.domesticandgeneral.com/repairs',
  },
  faq: {
    label: 'Help and advice',
    href: 'https://www.domesticandgeneral.com/content/help-advice-section/faq',
  },
};
const privacyLink = {
  section: 'legal',
  label: 'Privacy and Cookies policy',
  href: 'https://www.skyprotect.com/privacy-cookies-policy',
  newWindow: true,
};
const footerLinks: NavigationLink[] = [
  {
    section: 'more',
    label: 'Quote & buy',
    href: './quote',
    newWindow: true,
  },
  {
    section: 'more',
    label: 'Repairs',
    href: 'https://www.skyprotect.com/RepairClaimPageView?catalogId=11201&langId=44&storeId=11151',
    newWindow: true,
  },
  {
    section: 'useful',
    label: 'Support',
    href: 'https://www.skyprotect.com/faq',
    newWindow: true,
  },
  {
    section: 'useful',
    label: 'Contact us',
    href: 'https://www.skyprotect.com/contact',
    newWindow: true,
  },
  {
    section: 'useful',
    label: 'Received a letter',
    href: 'https://www.skyprotect.com/TopCategoriesDisplay?storeId=11151&renew=true',
    newWindow: true,
  },
  {
    section: 'useful',
    label: 'Sky Security Centre',
    href: 'https://www.sky.com/shop/broadband-talk/broadband-shield/staying-safe-online',
    newWindow: true,
  },
  {
    section: 'legal',
    label: 'Terms of Website Use',
    href: 'https://www.skyprotect.com/web-terms-conditions',
    newWindow: true,
  },
  privacyLink,
  {
    section: 'legal',
    label: 'Accessibility Policy',
    href: 'https://www.skyprotect.com/accessibility',
    newWindow: true,
  },
];
export const DEFAULT_ENVIRONMENT = {
  header: headerLinks,
  footer: {
    links: footerLinks,
  },
  links: {
    privacy: privacyLink,
  },
  defaultRequestSource: 'SKYPUK',
  dd_guarantee: 'https://www.domesticandgeneral.com/direct-debit-guarantee',
  wlClient: 'SKYPUK',
  catalogueStore: 'SKYPUK',
  cookieProSrc: 'https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js',
  action: 'QandB',
  quotePage: '/quote',
  checkoutLandingPage: '/checkout',
  checkoutOrderConfirmationPage: '/checkout/order-confirmation',
  applianceDetailsPage: '/quote',
  checkoutPersonalDetailsPage: '/checkout/personal-details',
  checkoutDirectDebitPage: '/checkout/direct-debit-payment',
  checkoutCardPaymentPage: '/checkout/card-payment',
  checkoutLoggedInUserPage: '/checkout/logged-in',
  selectPaymentPage: '/checkout/select-payment',
  forgotPasswordPage: '/forgot-password',
  cms_config: {
    pagesRoot: '/dgx-sales',
    insideCmsEditor: false,
    logCmsRequests: false,
    useCachedCmsOutput: false,
    useFallbackCmsContent: false,
    cachedRouteBase: 'assets/cached-cms/pages',
    cachedContentAppBase: 'assets/cached-cms/content-apps/',
  },
  trustPilot: {
    businessUnitId: '4cb3113600006400050dfb02',
    templates: [
      {
        id: '5419b6ffb0d04a076446a9af',
        name: 'micro',
      },
      {
        id: '54ad5defc6454f065c28af8b',
        name: 'slider',
      },
    ],
  },
  cardPayment: {
    description: 'Sales',
    transactionSource: 'W',
    transactionType: 'W',
  },
  retryBackOffConfig: {
    maxRetries: 1,
    initialInterval: 3000,
    maxInterval: 3000,
  },
  postcodeServiceKey: 'ZG99-WD62-FP46-DC55',
  postcodeServiceFind:
    'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws',
  postcodeServiceRetrieve:
    'https://api.addressy.com/Capture/Interactive/Retrieve/v1/json3.ws',
  worldpay: {
    customisation: {
      fonts: {
        family: ['Museo Sans', 'Source Sans Pro', 'Arial'],
      },
      color: '#414141',
      buttons: {
        backgroundColor: '#038ad3',
        color: '#fff',
        border: {
          style: 'solid',
          color: '#038ad3',
          width: '5px',
          radius: '2px',
        },
        hover: {
          backgroundColor: '#0071bb',
          border: {
            color: '#0071bb',
          },
        },
      },
      inputs: {
        backgroundColor: '#ffffff',
        border: {
          style: 'solid',
          width: '1px',
          radius: '2px',
          color: '#757575',
        },
        placeholder: {
          color: '#001',
        },
        validation: {
          ok: {
            color: '#228415',
          },
          error: {
            color: '#af2c2b',
          },
        },
      },
      page: {
        backgroundColor: '#fff',
        color: '#333',
        border: {
          style: 'solid',
          color: '#ddd',
          width: '1px',
          radius: '2px',
        },
      },
    },
  },
  validLandingPages: ['/quote'],
  sessionInactivityDurationInMinutes: 20,
  appRoot: '',
  domainBasedRequestSources: [
    {
      pattern: /(store=MOB_VIP|add-mobile)/,
      requestSource: 'SKYMUK',
      action: 'QandBQR',
    },
    {
      pattern: /(store=MOB|add-mobile)/,
      requestSource: 'SKYMUK',
    },
    {
      pattern: /(store=ENG)/,
      requestSource: 'SKYPUK_ENG',
    },
    {
      pattern: /(store=VIP)/, // VIP journey
      requestSource: 'SKYVUK',
    },
    {
      pattern: /(store=OFFER)/, // 4 Months Free journey
      requestSource: 'SKYOFFERUK',
      action: 'QandB',
    },
  ],
};
